// extracted by mini-css-extract-plugin
export default {"unauthorisedContainer":"Unauthorised_unauthorisedContainer__rJ---"};